import { render, staticRenderFns } from "./PosterSet.vue?vue&type=template&id=1016b572&scoped=true"
import script from "./PosterSet.vue?vue&type=script&lang=js"
export * from "./PosterSet.vue?vue&type=script&lang=js"
import style1 from "./PosterSet.vue?vue&type=style&index=1&id=1016b572&prod&scoped=true&lang=less"
import style2 from "./PosterSet.vue?vue&type=style&index=2&id=1016b572&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016b572",
  null
  
)

export default component.exports